/**
 * POS register product behavior flags (fractional qty, ring-by-amount, etc.).
 * Only attach fields when the source has authoritative values — never coerce
 * unknown/missing values to false (that blocks API refresh and misroutes add flows).
 */

export function hasRegisterProductBehaviorFlags (product) {
  if (!product || typeof product !== 'object') return false
  return (
    typeof product.allow_fractional === 'boolean'
    && typeof product.ring_by_amount === 'boolean'
    && typeof product.always_enter_quantity === 'boolean'
    && typeof product.open_price === 'boolean'
  )
}

export function copyRegisterProductBehaviorFields (source, target = {}) {
  const out = { ...target }
  if (typeof source?.allow_fractional === 'boolean') {
    out.allow_fractional = source.allow_fractional
  }
  if (typeof source?.ring_by_amount === 'boolean') {
    out.ring_by_amount = source.ring_by_amount
  }
  if (typeof source?.always_enter_quantity === 'boolean') {
    out.always_enter_quantity = source.always_enter_quantity
  }
  if (typeof source?.open_price === 'boolean') {
    out.open_price = source.open_price
  }
  if (typeof source?.price_decimals === 'number') {
    out.price_decimals = source.price_decimals === 3 ? 3 : 2
  }
  return out
}

/** Metadata persisted on cart lines so edit-qty dialogs respect product rules. */
export function registerProductCartMetadata (product) {
  const meta = {}
  if (typeof product?.allow_fractional === 'boolean') {
    meta.allow_fractional = product.allow_fractional
  }
  if (typeof product?.price_decimals === 'number') {
    meta.price_decimals = product.price_decimals === 3 ? 3 : 2
  }
  return meta
}
